export default __webpack_public_path__ + "static/media/mask-man.5cdbcc27.svg";